module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_vm._m(0), _vm._v(" "), _c('emt-grid', {
    ref: "pqr-grid",
    attrs: {
      "resource": _vm.gridUrl,
      "items": _vm.itemsGrid,
      "edit": _vm.editUrl,
      "deleteUrl": _vm.deleteUrl,
      "btnDelete": _vm.btnDelete,
      "btnEdit": _vm.btnEdit,
      "btnDetail": _vm.btnDetail,
      "source": _vm.consult
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titlle_div"
  }, [_c('h5', {
    staticClass: "title"
  }, [_vm._v("Consultar PQR")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64d9629c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/emt-form-consult-pqr.vue
// module id = 186
// module chunks = 0